export default __webpack_public_path__ + "assets/537ec65f67dd99cc41aab09df4a36806.jpg";